export default __webpack_public_path__ + "static/media/Shemite Mercenary Wristbands.cb465fbc.jpg";